<template>
    <Breadcrumbs main="Apps" title="File Manager" />
    <div class="container-fluid">
        <div class="row">
            <fileSidebar />
            <fileContent />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const fileSidebar = defineAsyncComponent(() => import("@/components/theme/filemaneger/fileSidebar.vue"))
const fileContent = defineAsyncComponent(() => import("@/components/theme/filemaneger/fileContent.vue"))
</script>